// extracted by mini-css-extract-plugin
export default {"rootContainer":"CurrentStepIndicator_rootContainer__2twWV","hollowCircle":"CurrentStepIndicator_hollowCircle__3VQoB","filledCircle":"CurrentStepIndicator_filledCircle__ygRfA"};